import TableRow from '@mui/material/TableRow';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';
import Label from 'src/components/label';
import { ICSVFileTrackerDto } from 'src/types/csvFileTracker';
import { CSVFileStatus } from 'src/utils/enums';
import { paths } from 'src/routes/paths';
import { Link } from '@mui/material';

type Props = {
  row: ICSVFileTrackerDto;
};

export default function CSVFileTrackerTableRow({ row }: Props) {
  return (
    <>
      <TableRow hover>
        <AppTableCell value={row?.file_url?.split('/').pop()} />
        <AppTableCell
          value={
            <Link href={paths.dashboard.content.videos(row?.channelId)}>
              {row?.csv_files_channel?.name?.en}
            </Link>
          }
        />
        <AppTableCell
          value={
            <Label
              color={
                CSVFileStatus[row.status] == CSVFileStatus.in_progress
                  ? 'info'
                  : CSVFileStatus[row.status] == CSVFileStatus.pending
                    ? 'warning'
                    : CSVFileStatus[row.status] == CSVFileStatus.completed
                      ? 'success'
                      : CSVFileStatus[row.status] == CSVFileStatus.failed
                        ? 'error'
                        : 'default'
              }
            >
              {CSVFileStatus[row.status]}
            </Label>
          }
        />

        <AppTableCell value={row?.progress_percentage} />
      </TableRow>
    </>
  );
}
